import { Component, Injector, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { Patient } from 'app/core/interfaces/patient';
import { EncounterService } from 'app/core/http/services/encounter.service';
import { PatientService } from 'app/core/http/services/patient.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { OrganizationPatientEditComponent } from './patient-edit.component';

type OrganizationPatient = Patient & { last_appointment?: string };

@Component({
  selector: 'page-organization-patients',
  templateUrl: './patients.component.html',
  styleUrls: ['./patients.component.scss'],
})
export class OrganizationPatientsComponent extends BaseComponent implements OnInit {
  public title = 'Pacientes';
  public patients: OrganizationPatient[] = [];
  public filteredPatients: OrganizationPatient[] = [];
  public search = '';
  public override loading = false;

  constructor(
    private injector: Injector,
    private encounterService: EncounterService,
    private patientService: PatientService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadPatients();
  }

  loadPatients(): void {
    const organizationId = this.auth.currentUserValue.user.id;
    this.loading = true;
    this.encounterService.listFinishedPatientIdsByOrganization(organizationId).subscribe({
      next: (attendedPatients) => {
        if (!attendedPatients.length) {
          this.patients = [];
          this.applyFilter();
          this.loading = false;
          return;
        }

        forkJoin(attendedPatients.map((attendedPatient) => this.patientService.showNew(attendedPatient.patient_id))).subscribe({
          next: (patients) => {
            this.patients = patients.map((patient, index) => ({
              ...patient,
              last_appointment: attendedPatients[index].last_appointment,
            }));
            this.applyFilter();
            this.loading = false;
          },
          error: () => (this.loading = false),
        });
      },
      error: () => (this.loading = false),
    });
  }

  applyFilter(): void {
    const term = this.search.trim().toLocaleLowerCase();
    this.filteredPatients = term
      ? this.patients.filter(
          (patient) => patient.name.toLocaleLowerCase().includes(term) || (patient.cpf ?? '').replace(/\D/g, '').includes(term.replace(/\D/g, '')),
        )
      : [...this.patients];
  }

  editPatient(patient: OrganizationPatient): void {
    this.dialog
      .openComponentDialog(OrganizationPatientEditComponent, {
        title: 'Alterar nome do paciente',
        param: { patient },
      })
      .subscribe((updatedPatient?: Patient) => {
        if (!updatedPatient) return;
        this.patients = this.patients.map((item) => (item.patient_id === updatedPatient.patient_id ? updatedPatient : item));
        this.applyFilter();
      });
  }
}
